import { render, staticRenderFns } from "./el-select.vue?vue&type=template&id=143f8c82&scoped=true"
import script from "./el-select.vue?vue&type=script&lang=js"
export * from "./el-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143f8c82",
  null
  
)

export default component.exports